import { Season } from "../../types/entities/season";
import { EntityService } from "./entity-service";

export class SeasonService extends EntityService<Season> {}
